import React, { Component } from "react";
import axios from "@app/lib/axios";

import * as Constant from "../../../Constant.js";

import Spinner from "../../../components/Spinner";
import AppCurrentInfo from "./AppCurrentInfo.js";
import AppVersionLog from "./AppVersionLog.js";
import AppInfoModal from "./AppInfoModal.js";

class AppVersion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageInit: false,
            appModalShow: false,
            appList: [],
            platformList: [],
            tagList: [],
            selectedTag: null,
            selectedApp: null,
        };
    }

    componentDidMount = () => {
        this.pageLoad();
    };

    pageLoad = (appId) => {
        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/app_version/init",
        })
            .then((result) => {
                let app = null;
                if (result.data && result.data.appList && result.data.appList.length > 0) {
                    if (appId) app = result.data.appList.filter((a) => a.id === appId)[0];
                    else app = result.data.appList[0];
                }

                this.setState({
                    ...result.data,
                    selectedApp: app,
                });
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    render() {
        const { appList, platformList, tagList, selectedTag, selectedApp, appModalShow } = this.state;

        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">앱 업데이트 이력</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content">
                        <div className="row">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                                <div className="card border-top border-top-primary">
                                    <div className="card-header">
                                        <div className="input-group">
                                            <select
                                                className="form-control"
                                                disabled={tagList.length === 0}
                                                value={this.state.selectedTag}
                                                onChange={(e) => {
                                                    let selectedApp = appList[0];
                                                    if (e.target.value != 999 && e.target.value != 0) {
                                                        selectedApp = appList.filter((a) => a.tags == e.target.value && a.on_service)[0];
                                                    } else if (e.target.value != 0) {
                                                        selectedApp = appList.filter((a) => !a.on_service)[0];
                                                    }

                                                    this.setState({
                                                        selectedTag: e.target.value,
                                                        selectedApp: selectedApp,
                                                    });
                                                }}
                                            >
                                                <option value="0">전체</option>
                                                {tagList.map((tag) => {
                                                    return (
                                                        <option key={tag.id} value={tag.id}>
                                                            {tag.name}
                                                        </option>
                                                    );
                                                })}
                                                <option value="999">종료된 서비스</option>
                                            </select>
                                            <select
                                                className="form-control"
                                                disabled={appList.length === 0}
                                                value={this.state.selectedApp ? this.state.selectedApp.id : 0}
                                                onChange={(e) => {
                                                    this.setState({
                                                        selectedApp: appList.filter((a) => a.id == e.target.value)[0],
                                                    });
                                                }}
                                            >
                                                {appList.map((app) => {
                                                    if (selectedTag > 0) {
                                                        if (app.tags == selectedTag && app.on_service) {
                                                            return (
                                                                <option key={app.id} value={app.id}>
                                                                    {app.name}
                                                                </option>
                                                            );
                                                        } else if (selectedTag == 999 && !app.on_service) {
                                                            return (
                                                                <option key={app.id} value={app.id}>
                                                                    {app.name}
                                                                </option>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    } else {
                                                        if (app.on_service) {
                                                            return (
                                                                <option key={app.id} value={app.id}>
                                                                    {app.name}
                                                                </option>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    }
                                                })}
                                            </select>
                                            <div className="input-group-append">
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => {
                                                        this.setState({
                                                            appModalShow: true,
                                                        });
                                                    }}
                                                >
                                                    <span className="fas fa-plus-circle" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <AppCurrentInfo appId={selectedApp ? selectedApp.id : 0} update_date={new Date()} tagList={tagList} platformList={platformList} dataCallback={this.pageLoad} />
                                    <AppInfoModal
                                        show={appModalShow}
                                        onHide={() => {
                                            this.setState({
                                                appModalShow: false,
                                            });
                                        }}
                                        tagList={tagList}
                                        platformList={platformList}
                                        dataCallback={this.pageLoad}
                                    />
                                </div>
                            </div>

                            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
                                <AppVersionLog
                                    appId={this.state.selectedApp ? this.state.selectedApp.id : 0}
                                    update_date={new Date()}
                                    dataCallback={(appId) => {
                                        this.pageLoad(appId);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AppVersion;
